import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { PosIntegrationService } from '../../../../services/pos-integration.service';
import { ProductsService } from '../../../../services/products.service';
import { HelpersService } from '../../../../services/helpers.service';
import { PartnerService } from '../../../../services/partner.service';
import { AppConfig } from '../../../../app.config';
import { ConnectPosComponent } from '../../../modals/connect-pos/connect-pos.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-pos-integrations',
  templateUrl: './pos-integrations.component.html',
  styleUrls: ['./pos-integrations.component.scss'],
  providers: [MessageService],
})
export class PosIntegrationsComponent implements OnInit {
  public partner: any = {};
  public busy: boolean = false;
  public POSSytems = [];
  public POSSystemID = 0;
  public posIntegration: any = {};
  public selectPOS: any = {};
  public showIntegrations: boolean = false;
  public orginizationName: string;
  public isRentals = false;

  constructor(
    private helpersService: HelpersService,
    private posIntegrationService: PosIntegrationService,
    public messageService: MessageService,
    private translate: TranslateService,
    private appConfig: AppConfig,
    private confirmationService: ConfirmationService,
    public modalService: NgbModal,
    public partnerService: PartnerService,
    private router: Router,
    private productsService: ProductsService
  ) { }

  ngOnInit() {
    if (
      this.router.url.toLocaleLowerCase() ===
      '/store/rentals/pos-integrations'
    ) {
      this.isRentals = true;
    }
    this.POSSytems = this.isRentals
      ? this.appConfig.getSupportedRentalPOSSystems()
      : this.appConfig.getSupportedPOSSystems();
    this.checkPOSIntegration();
  }

  checkPOSIntegration() {
    this.busy = true;
    this.partner = this.helpersService.getPartnerData();

    this.partnerService.getPartnerDetail(this.helpersService.getPartnerId()).subscribe(
      (partner) => {
        this.partner = partner;
        if (this.partner.POSSystemID > -1) {
          this.POSSystemID = this.partner.POSSystemID;
        }
        this.posIntegrationService
          .checkPOSIntegration(this.helpersService.getPartnerId(), this.POSSystemID)
          .subscribe(
            (res) => {
              this.posIntegration = res;
              this.posIntegration = {
                ...this.posIntegration,
                ...this.appConfig
                  .getSupportedPOSSystems()
                  .filter((x) => {
                    return x.POSID === this.posIntegration.ConnectedPOS;
                  })
                  .pop(),
              };
              this.showIntegrations =
                this.appConfig.getSupportedPOSSystems().filter((x) => {
                  return x.POSID === this.POSSystemID;
                }).length > 0;
              this.orginizationName = res.orginizationName;
              this.busy = false;
            },
            (err) => {
              this.posIntegration = {};
              //this.POSSystemID = 0;
              this.busy = false;
              if (
                this.partner.POSSystemID <= 0 ||
                this.appConfig.getSupportedPOSSystems().filter((x) => {
                  return x.POSID === this.POSSystemID;
                }).length > 0
              ) {
                this.showIntegrations = true;
              }
            },
          );
      },
      (err) => {
        this.checkPOSIntegration();
      },
    );
  }

  disconnectPOS() {
   this.busy = true;
    this.confirmationService.confirm({
      key: 'pos_confirmation',
      rejectVisible: true,
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.ok'),
      header: this.translate.instant(
        'bikeshop.shop_profile.pos-integration.button.disconnect_pos',
      ),
      message: this.translate.instant(
        'bikeshop.shop_profile.pos-integration.disconnect_pos_message',
      ),
      accept: () => {       
        // Disconnect integration
            this.posIntegrationService
              .disconnectPOSIntegration(this.partner.ID)
              .subscribe(
                (disconnect) => {
                  this.busy = false;
                  this.messageService.add({
                    life: 5000,
                    detail: this.translate.instant(
                      'bikeshop.shop_profile.pos-integration.pos_disconnected_message',
                    ),
                  });
                  this.checkPOSIntegration();
                  this.deletePOSProducts();
                },
                (err) => {
                  this.checkPOSIntegration();
                },
              );
      },
      reject: () => {
        this.busy = false;
      },
    });
  }

  disconnectPOS_WithAuth() {
   this.busy = true;
    this.confirmationService.confirm({
      key: 'pos_confirmation',
      rejectVisible: true,
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.ok'),
      header: this.translate.instant(
        'bikeshop.shop_profile.pos-integration.button.disconnect_pos',
      ),
      message: this.translate.instant(
        'bikeshop.shop_profile.pos-integration.disconnect_pos_message',
      ),
      accept: () => {       
        // First disconnect POS Auth, then integration
        this.posIntegrationService.disconnectPOSAuth(this.partner.ID).subscribe({
          next: (res) => {
            // Disconnect integration
            this.posIntegrationService
              .disconnectPOSIntegration(this.partner.ID)
              .subscribe(
                (disconnect) => {
                  this.busy = false;
                  this.messageService.add({
                    life: 5000,
                    detail: this.translate.instant(
                      'bikeshop.shop_profile.pos-integration.pos_disconnected_message',
                    ),
                  });
                  this.checkPOSIntegration();
                  this.deletePOSProducts();
                },
                (err) => {
                  this.checkPOSIntegration();
                },
              );
          },
          error: (err) => {
            console.error('Error disconnecting POS auth', err);
          }
        });
      },
      reject: () => {
        this.busy = false;
      },
    });
  }


  deletePOSProducts() {
    this.confirmationService.confirm({
      key: 'pos_confirmation',
      rejectVisible: true,
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('bikeshop.pos_products.bulk_delete_all'),
      header: this.translate.instant(
        'bikeshop.pos_products.bulk_delete_all',
      ),
      message: this.translate.instant(
        'bikeshop.shop_profile.pos-integration.delete_all_products',
      ),
      accept: () => {
        var data = {
          ClearAllProducts: true,
          ProductIDs: []
        }
        this.productsService.removePOSProducts(this.helpersService.getPartnerId(), data).subscribe(res => {
          this.messageService.add({
            life: 5000,
            detail: this.translate.instant(
              'bikeshop.pos_products.bulk_delete_completed',
            ),
          });
          this.getProducts();
        })
      },
      reject: () => {

      },
    });
  }

  getProducts() {
    var partnerData = this.helpersService.getPartnerData();
    if (partnerData.POSSystemID <= 10) {
      this.productsService
        .getAllProductsWithGear(this.helpersService.getPartnerId())
        .subscribe((products) => {
          this.helpersService.saveProductData(products);
        });
    } else {
      this.productsService
        .syncNewProducts(partnerData.ID)
        .subscribe((products) => {
          this.productsService
            .getAllProductsWithGear(this.helpersService.getPartnerId())
            .subscribe((products) => {
              this.helpersService.saveProductData(products);
            }, err => {

            });
        });
    }
  }

  setPOSSystemID(ID) {
    this.POSSystemID = ID;
    this.selectPOS = this.POSSytems.filter((x) => {
      return x.POSID === this.POSSystemID;
    }).pop();

    const modalRef = this.modalService.open(ConnectPosComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    this.partner.PartnerID = this.partner.ID;
    modalRef.componentInstance.partner = this.partner;
    modalRef.componentInstance.selectPOS = this.selectPOS;
    modalRef.result.then(
      (result) => {
        this.checkPOSIntegration();
      },
      (onrejected) => {
        this.checkPOSIntegration();
      },
    );
  }
}
